export const LOCK_BUSY = Symbol('lock-busy');

const LEASE_MS = 30000;
const tabId = Math.random().toString(36).slice(2);

/**
 * Run `fn` only if no other tab holds the lock; otherwise return LOCK_BUSY.
 * Web Locks API (Safari 15.4+, all modern browsers) with a localStorage lease
 * fallback for older engines.
 */
export async function withLock(name, fn) {
  if (typeof navigator !== 'undefined' && navigator.locks?.request) {
    return navigator.locks.request(name, { ifAvailable: true }, (lock) => (lock ? fn() : LOCK_BUSY));
  }
  return withLease(name, fn);
}

async function withLease(name, fn) {
  const key = `recall.lock.${name}`;
  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch {
      return null;
    }
  };
  const held = read();
  if (held && held.owner !== tabId && held.expires > Date.now()) return LOCK_BUSY;
  const write = () => localStorage.setItem(key, JSON.stringify({ owner: tabId, expires: Date.now() + LEASE_MS }));
  write();
  const renew = setInterval(write, LEASE_MS / 3);
  try {
    return await fn();
  } finally {
    clearInterval(renew);
    if (read()?.owner === tabId) localStorage.removeItem(key);
  }
}
